import {authGuard} from '@common/auth/guards/auth-route';
import {RouteObject} from 'react-router';

export const adminSecurityRoutes: Record<string, RouteObject> = {
  virusScan: {
    path: 'security/virus-scan',
    lazy: () => import('@common/admin/security/virus-scan-page'),
    loader: () => authGuard({permission: 'admin.access'}),
  },
};
